export default __webpack_public_path__ + "static/media/frontEndDImg.dd481f80.png";